export const LANDING_STATUS_PATH = "shopSettings.landingPage.status";
export const CATEGORY_PATH = "shopSettings.landingPage.category";
// export const NEW_PRODUCT_TAG_PATH = "shopSettings.landingPage.tag.newProduct";
// export const HOME_SPECIAL_PRODUCT_PATH =
//   "shopSettings.landingPage.home.specialProduct";
export const BANNER_TAG_PATH = "shopSettings.landingPage.tag.banners";
export const SPECIAL_PRODUCT_TAG_PATH =
  "shopSettings.landingPage.tag.specialProduct";
export const FESTIVAL_PRODUCT_TAG_PATH =
  "shopSettings.landingPage.tag.festivalProduct";
export const SHARE_STORE_IMAGE_PATH =
  "shopSettings.landingPage.image.shareStore";
export const RECOMMAND_PRODUCT_TAG_PATH =
  "shopSettings.landingPage.tag.recommedProduct";
// export const RECOMMAND_PRODUCT_PATH =
//   "shopSettings.landingPage.home.recommedProduct";
//export const SECTION_PATH = "shopSettings.landingPage.sections";
export const SECTION_PATH = "landingPage";
export const BANNER_SKU = "bannerSku";
export const HERO_SKU = "heroSku";
export const COLLECTION_SKU = "collectionSku";
export const CATEGORY_SKU = "categorySku";

export const APPRECIATION_PERIOD_PATH = "shopSettings.appreciationPeriod";
export const DELIVERY_FEE_PATH = "shopSettings.delivery_fee";
